export default {
  async setSignupModalOpen({ commit }, payload) {
    return commit('SET_SIGNUP_MODAL_OPEN', payload)
  },
}
